<template>
  <div v-loading="loading" class="wrapper">
    <!-- 语音助手组件 -->
    <VoiceAssistant 
      ref="voiceAssistant"
      v-if="showVoice"
      :auto-call-ai="true"
      :initial-position="{ x: null, y: 120 }"
      @voice-recognition-complete="handleVoiceRecognition"
      @ai-response="handleAIResponse"
      @ticket-response="handleTicketResponse"
      @ai-error="handleAIError"
    />
    <div class="todo-box">
      <div class="content" :style="{ height: height + 'px' }">
        <div class="nav" :class="[{ 'is-fold': isFold }]">
          <van-sidebar class="sidebar" v-model="sidebarNum" @change="getWhereType">
            <van-sidebar-item
              :class="[{ 'is-fold': isFold }, 'navbar']"
              v-for="item in titleLists"
              :key="item.name"
              :title="item.name"
              :badge="item.count"
            />
          </van-sidebar>
        </div>
        <div :class="['list-box', { 'is-stretch': isFold }]">
          <div :class="['flex-vc', 'todo-title', { 'is-stretch': isFold }]">
            <div @click="isFold = !isFold" class="ml5 icon-left">
              <el-icon class="f20" name="s-unfold" v-if="isFold" />
              <el-icon class="f20" name="s-fold" v-else />
            </div>
            <h4 style="text-align: center; font-weight: 500" class="w m10 f16">
              待办列表({{ total || 0 }})
            </h4>
            <div class="mr5 icon-left" style="display: flex">
              <van-icon name="search" v-if="hasSearch" class="f20" @click="hasSearch = false" />
              <van-icon name="arrow-up" v-else class="f20" @click="onCancel" />
            </div>
          </div>
          <transition name="fade" appear v-if="!hideTypingSearch">
            <div
              key="search"
              v-show="!hasSearch"
              :class="[hasSearch ? 'hide-search' : 'show-search', { 'is-stretch': isFold }]"
            >
              <!-- 搜索框区域 -->
              <div style="padding: 8px 12px;">
                <scanner 
                  @enter="checkSearch" 
                  @cancel="onCancel" 
                  :searchValue="searchValue" 
                  :placeholder="'支持语音、图片识别和扫码搜索'"
                ></scanner>
              </div>
              
              <!-- 辅助输入工具栏 -->
              <div 
                v-if="showVoice || showOcr" 
                style="display: flex; align-items: center; padding: 4px 12px 8px 12px; gap: 12px; border-top: 1px solid #f0f0f0;"
              >
                <!-- 语音输入 -->
                <div 
                  v-if="showVoice && !isVoiceModalOpen" 
                  @click="openVoiceSearch"
                  class="toolbar-button"
                  @mousedown="handleToolbarMouseDown"
                  @mouseup="handleToolbarMouseUp"
                  @mouseleave="handleToolbarMouseUp"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style="color: #52c41a; flex-shrink: 0;">
                    <rect x="9" y="4" width="6" height="10" rx="3" stroke="currentColor" stroke-width="2" fill="none"/>
                    <path d="M6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <line x1="12" y1="18" x2="12" y2="21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <line x1="9" y1="21" x2="15" y2="21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <span class="toolbar-button__text">语音输入</span>
                </div>
                
                <!-- OCR识别 -->
                <ImageUploadInput
                  v-if="showOcr"
                  field-name="todoSearch"
                  field-title="图片识别"
                  :new-choose-image="true"
                  :show-toolbar-style="true"
                  @ocr-text-selected="handleOcrTextSelected"
                />
              </div>
            </div>
          </transition>

          <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="todo-list">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              offset="10"
              :class="[
                hasSearch ? 'hide-search-list' : 'show-search-list',
                (showVoice || showOcr) ? 'with-toolbar' : 'without-toolbar'
              ]"
            >
              <van-collapse v-model="activeName">
                <div v-for="item in ticketList" :key="item.TaskId || item.TaskOrderId">
                  <van-collapse-item :name="item.TaskId || item.TaskOrderId">
                    <template #title>
                      <div>
                        <van-tag
                          v-if="URGENT_TYPE[item.IsUrgent]"
                          effect="dark"
                          class="mr5"
                          size="small"
                          :type="URGENT_TYPE[item.IsUrgent].color"
                          disable-transitions
                        >
                          {{ URGENT_TYPE[item.IsUrgent].text || '紧急' }} </van-tag
                        ><span
                          :class="
                            URGENT_TYPE[item.IsUrgent]
                              ? 'color-' + URGENT_TYPE[item.IsUrgent].color
                              : ''
                          "
                          >{{
                            `[${item.TypeName || item.Type || '暂无分类'}]${
                              item.TodoName || item.TitleContent
                            }`
                          }}</span
                        >
                      </div>
                    </template>
                    <div class="details-box">
                      <table class="w">
                        <tr v-for="item in item.TodoDesc" :key="item.key">
                          <td class="f700 text-r">
                            {{ item.key }}
                          </td>
                          <td class="pl5 pr5" style="white-space: pre-line" v-html="item.value" />
                        </tr>
                      </table>
                      <div class="foot">
                        <div class="foot-item">
                          <van-button
                            size="small"
                            style="background-color: #327aee; color: #ffffff"
                            @click="gotoDetail(item)"
                          >
                            去处理
                          </van-button>
                        </div>
                      </div>
                    </div>
                  </van-collapse-item>
                </div>
              </van-collapse>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOtobTicket, getAllType, getOverAllType, getOverTicket, getPingTodoData } from '@/api/tickets/ticketsApi';
import { mapGetters } from 'vuex';
import { Notify, Dialog } from 'vant';
import Scanner from './Scanner.vue';
import VoiceAssistant from '@/components/VoiceAssistant/todoAssist.vue';
import ImageUploadInput from '@/components/Formily/ImageUploadInput.vue';
import '@/assets/iconfont/iconfont.css';
import router from '../router/router';
export default {
  components: {
    Scanner,
    VoiceAssistant,
    ImageUploadInput,
  },
  computed: {
    ...mapGetters(['getConfigItem']),
  },
  data() {
    return {
      overView: {
        index: '',
        key: '',
      },
      URGENT_TYPE: {
        1: {
          text: '紧急',
          color: 'danger',
        },
        2: {
          text: '加急',
          color: 'warning',
        },
      },
      // 工单类型判断条件
      height: window.innerHeight,
      Type: '',
      TaskTypeId: '',
      TotalRows: '',
      //分页列表渲染
      List: [],
      ticketList: [],
      searchStr: this.$route.query?.search,
      total: 0,
      // 分页展示数据
      dataValueList: [],
      isFold: this.getSavedSidebarFoldState(),
      isLoading: false,
      activeName: [],
      sidebarNum: parseInt(this.$route.query.num) || 0,
      loading: false,
      finished: true,
      hasSearch: !this.$route.query?.search,
      refreshing: false,
      // 数据类型展示
      titleLists: [],
      // 总览跳转数据类型
      overViewTitLists: [],
      //userId
      UserID: sessionStorage.getItem('userid'),
      searchValue: '',
      // 存储用户的完整语音输入（用于重新调用混元API）
      lastUserVoiceQuery: '',
      // 深度搜索控制
      isDeepSearching: false,
      deepSearchCancelled: false,
      // 深度搜索Toast实例
      deepSearchToast: null,
      // 待打开的工单信息（用于语音确认）
      pendingTicketToOpen: null,
      showVoice: false,
      // OCR识别组件是否显示
      showOcr: false,
      // 语音助手弹框是否打开
      isVoiceModalOpen: false,
      // 弹框状态检查定时器
      modalCheckTimer: null,
      // 工具栏按钮按下状态
      isToolbarButtonPressed: false,
      isInGrayList: false,
    };
  },
  watch: {
    // 监听isChecked数组的变化，并更新showBtn的值
    isChecked: {
      handler(newVal) {
        this.showBtn = newVal.length > 0;
      },
      deep: true,
    },
    // 监听isFold变化，保存到localStorage
    isFold: {
      handler(newVal) {
        localStorage.setItem('todoSidebarFold', JSON.stringify(newVal));
      },
    },
  },
  async created() {
    window.addEventListener('resize', () => {
      // We execute the same script as before
      this.height = window.innerHeight;
    });
    await this.getTaskType();
    if (this.$route.query.type) {
      await this.getOverviewType();
    } else {
      if (sessionStorage.getItem('key')) {
        // await this.getTicketByType(this.sidebarNum || 0, this.searchStr);

        this.searchStr = sessionStorage.getItem('key');
        this.searchValue = sessionStorage.getItem('key');
        this.onSearch(this.searchStr);
      } else {
        await this.getTicketByType(this.sidebarNum || 0, this.searchStr);
      }
    }
  },
  mounted() {
    this.initUsers();
  },
  beforeDestroy() {
    // 清理定时器
    if (this.modalCheckTimer) {
      clearInterval(this.modalCheckTimer);
      this.modalCheckTimer = null;
    }
  },
  methods: {
     // 处理工具栏按钮按下
     handleToolbarMouseDown(event) {
      event.currentTarget.style.background = '#e6e6e6';
    },
    
    // 处理工具栏按钮释放
    handleToolbarMouseUp(event) {
      event.currentTarget.style.background = '#f7f8fa';
    },
    
     openVoiceSearch() {
      console.log('[TodoPage] 打开语音搜索');
      if (!(this.showVoice)) {
        this.hasSearch = false
        return
      }
      
      // 检查语音助手组件是否存在
      if (!this.$refs.voiceAssistant) {
        console.error('[TodoPage] 语音助手组件不存在');
        this.$toast({
          message: '语音助手未加载',
          type: 'fail',
          duration: 2000
        });
        return;
      }
      
      // 清除之前的定时器
      if (this.modalCheckTimer) {
        clearInterval(this.modalCheckTimer);
        this.modalCheckTimer = null;
      }
      
      // 设置弹框打开状态，隐藏语音图标
      this.isVoiceModalOpen = true;
      
      // 调用语音助手组件的方法打开弹窗
      this.$refs.voiceAssistant.showVoiceModal();
      
      // 监听弹框关闭事件（通过定时检查）
      this.modalCheckTimer = setInterval(() => {
        if (this.$refs.voiceAssistant && !this.$refs.voiceAssistant.voiceModalVisible) {
          this.isVoiceModalOpen = false;
          clearInterval(this.modalCheckTimer);
          this.modalCheckTimer = null;
          console.log('[TodoPage] 语音助手弹框已关闭，恢复显示语音图标');
        }
      }, 500);
      
      // 等待弹窗打开后自动开始录音
      this.$nextTick(() => {
        setTimeout(() => {
          // 调用语音助手组件的开始录音方法
          this.$toast({
          message: '请说出关键词，例如：搜索尾号3456的工单',
          type: 'info',
          duration: 2000
        });
          if (this.$refs.voiceAssistant) {
            this.$refs.voiceAssistant.startClickRecording();
            console.log('[TodoPage] 已自动开始录音');
          }
        }, 300); // 延迟300ms确保弹窗已完全打开
      });
    },
    
    // 处理OCR识别的文本
    handleOcrTextSelected(text) {
      console.log('[TodoPage] OCR识别文本:', text);
      
      if (!text || !text.trim()) {
        this.$toast({
          message: '未识别到有效文本',
          type: 'warning',
          duration: 2000
        });
        return;
      }
      
      // 将识别的文本填入搜索框
      this.searchValue = text.trim();
      this.searchStr = text.trim();
      
      // Aegis打点：OCR文本用于搜索
      try {
        const { aegis } = this.$store.state.user;
        if (aegis) {
          aegis.infoAll({
            msg: JSON.stringify({
              action: 'ocr_text_search',
              component: 'TodoPage',
              searchText: text.trim(),
              timestamp: new Date().toISOString()
            }),
            ext1: 'ocr-search',
            trace: 'ocr-text-search',
          });
        }
      } catch (reportError) {
        console.error('[TodoPage] Aegis上报失败:', reportError);
      }
      
      // 自动执行搜索
      this.checkSearch(text.trim());
      
      this.$toast({
        message: '已自动搜索识别的文字',
        type: 'success',
        duration: 2000
      });
    },
    
    initUsers() {
      try {
        const users = JSON.parse(this.getConfigItem('showVoice'));
        const useVoiceSearch = JSON.parse(this.getConfigItem('useVoiceSearch'));
        const shouOcr = this.getConfigItem('shouOcr');
        
        if (users?.includes?.(sessionStorage.getItem('userid'))) {
          this.showVoice = true
        }
        if (useVoiceSearch?.includes?.(sessionStorage.getItem('userid'))) {
          this.useVoiceSearch = true
        }
        
        // 读取OCR配置
        if (shouOcr === '1') {
          this.showOcr = true;
          console.log('[TodoPage] OCR识别组件已启用');
        }
        
        this.hideTypingSearch = this.useVoiceSearch && this.getConfigItem('hideTypingSerch')
        // 判断当前用户是否在灰度名单中
        try {
          const grayList = JSON.parse(this.getConfigItem('uiGrayList') || '[]');
          if (grayList?.includes?.(sessionStorage.getItem('userid'))) {
            this.isInGrayList = true;
          }
        } catch (e) {}
      } catch (e) {
        console.error('[TodoPage] 初始化配置失败:', e);
      }

    },
    // 获取保存的侧边栏折叠状态
    getSavedSidebarFoldState() {
      try {
        const saved = localStorage.getItem('todoSidebarFold');
        return saved !== null ? JSON.parse(saved) : false;
      } catch (e) {
        console.error('[TodoPage] 读取侧边栏状态失败:', e);
        return false;
      }
    },
    async submitTransferForm() {
      try {
        Notify({
          message: `正在批量转单，数量为 ${this.isChecked.length} 单`,
          type: 'warning',
          duration: 0,
          offset: 50,
        });
        for (let i = 0; i < this.isChecked.length; i++) {
          const item = this.isChecked[i];
          await handoverTodo(
            this.transferPerson.name,
            sessionStorage.getItem('userid'),
            item.TaskId
          );
        }
        Notify({ type: 'success', message: '操作成功' });
        this.isChecked = [];
        await this.getTicketByType(this.sidebarNum || 0);
      } catch (err) {
        Notify({ type: 'danger', message: `操作失败：${err.message}` });
      }
    },

    // 批量转单
    showHandoverTodo() {
      this.transferDialog = true;
    },

    // 勾选工单
    changes(data, index) {
      const ticketId = data.TicketId;
      const taskId = data.TaskId;
      this.ticketList[index].Checked = !this.ticketList[index].Checked;

      if (this.ticketList[index].Checked) {
        if (!this.isChecked.some((item) => item.TicketId === ticketId)) {
          this.isChecked.push({ TicketId: ticketId, TaskId: taskId });
        }
      } else {
        const idx = this.isChecked.findIndex((item) => item.TicketId === ticketId);
        if (idx > -1) {
          this.isChecked.splice(idx, 1);
        }
      }
    },

    checkSearch(val) {
      const isKeywordValid = val && val.length >= 2;
      if (isKeywordValid || !val) {
        this.onSearch(val);
      } else {
        Notify({ type: 'warning', message: '使用关键字搜索，请输入至少2个字符' });
      }

    },

    async onSearch(val) {
      this.searchStr = val;
      sessionStorage.setItem('key', val || '');
      try {
        this.loading = true;
        const { List, TotalRows } = await getOtobTicket({
          Type: this.Type,
          KeyWords: val,
        });
        this.$router.replace({ path: '/todo', query: { num: this.sidebarNum || 0, search: val } });
        this.ticketList = List.map((item) => ({
          ...item,
          TodoDesc: this.parseJson(item.TodoDesc || '[]'),
        }));
        this.activeName = this.ticketList.map((item) => item?.TaskId || item?.TaskOrderId);
      } catch (e) {
        console.log(e);
        this.$toast(e);
      } finally {
        this.loading = false;
      }
    },
    onCancel() {
      this.searchValue = '';
      this.hasSearch = true;
      this.onSearch('');
    },
    
    // 取消深度搜索
    cancelDeepSearch() {
      console.log('[TodoPage] 用户取消深度搜索');
      
      // 设置取消标志
      this.deepSearchCancelled = true;
      this.isDeepSearching = false;
      
      // 关闭Dialog
      if (this.deepSearchToast) {
        this.deepSearchToast = null;
        Dialog.close();
      }
      
      // 通知语音助手组件取消API调用
      if (this.$refs.voiceAssistant) {
        this.$refs.voiceAssistant.cancelApiCall();
      }
      
      // 清空搜索关键词
      this.searchValue = '';
      this.searchStr = '';
      sessionStorage.removeItem('key');
      
      // 重新加载待办列表（不带关键词）
      this.onSearch('');
      
      // 显示取消提示
      this.$toast({
        message: '已取消深度搜索',
        type: 'success',
        duration: 2000
      });
    },
    
    //左侧数量类型统计
    async getOverviewType() {
      try {
        console.log(sessionStorage.getItem('titleLists'), "sessionStorage.getItem('titleLists')")
        if (sessionStorage.getItem('titleLists')) {
          const titleLists = JSON.parse(sessionStorage.getItem('titleLists'));
          if (Array.isArray(titleLists)) {
            this.titleLists = titleLists;
            return;
          } else {
            this.titleLists = [];
          }
        }
      } catch (e) {}
      try {
        const res = await getOverAllType();
        this.titleLists = res.map((item) => ({
          name: item.TypeName || item.Type,
          value: item.Type,
          count: item.amount,
        }));
        this.titleLists.unshift({
          name: '全部待办',
          value: '',
          count: this.titleLists.reduce((res, item) => parseInt(item.count) + res, 0),
        });
        sessionStorage.setItem('titleLists', JSON.stringify(this.titleLists));
        this.getGoindex(this.$route.query.type);
      } catch (e) {
        console.log(e);
      }
    },
    //总览页面分页查询
    async getOverTicket(i) {
      console.log('6 正常触发getOverTicket');
      console.log(i, 'over');
      const { value } = this.titleLists[i || 0] || {value: ''};
      this.$router.replace({ path: '/todo', query: { num: i } });
      this.Type = value;
      this.loading = true;
      try {
        const { List, TotalRows } = await getOverTicket({
          Type: value,
        });
        this.ticketList = List.map((item) => ({
          ...item,
          TodoDesc: this.parseJson(item.TodoDesc || '[]'),
        }));
        this.activeName = this.ticketList.map((item) => item?.TaskId || item?.TaskOrderId);
        this.total = TotalRows;
        this.titleLists[i || 0].count = TotalRows;
      } catch (e) {
        this.$toast(e);
      } finally {
        this.loading = false;
        sessionStorage.setItem('titleLists', JSON.stringify(this.titleLists));
      }
    },
    //当前id下的某个工单的下标
    getGoindex(type) {
      console.log('3 进入getGoindex');
      this.overView.key = this.$route.query.key;
      let index = this.titleLists.findIndex((item) => item.value == type);
      this.overView.index = index;
      this.sidebarNum = index;
      if (index) {
        this.getWhereType();
        return;
      }
      if (index === -1) {
        // this.$toast(`当前账号没有(${type})工单类型，请返回上级页面`)
        Notify(`当前账号没有(${type})类型工单，请返回上级页面`);
        return;
      }
    },
    //判断是走总览的方法还是todo的方法
    getWhereType() {
      console.log('4 getWhereType');
      
      // 清空搜索关键词和关闭搜索框
      this.searchValue = '';
      this.searchStr = '';
      this.hasSearch = true; // 关闭搜索框
      sessionStorage.removeItem('key'); // 清除sessionStorage中的搜索关键词
      
      const key = this.overView.key;
      if (key === 'overview') {
        console.log('5 getOverTicket');
        this.getOverTicket(this.sidebarNum || 0);
        return;
      } else {
        this.getTicketByType(this.sidebarNum || 0);
      }
    },
    // 获取数据类型
    async getTaskType() {
      try {
        console.log(sessionStorage.getItem('titleLists'), "sessionStorage.getItem('titleLists')")
        if (sessionStorage.getItem('titleLists')) {
          const titleLists = JSON.parse(sessionStorage.getItem('titleLists'));
          if (Array.isArray(titleLists)) {
            this.titleLists = titleLists;
            return;
          } else {
            this.titleLists = [];
          }
        }
      } catch (e) {}
      try {
        const res = await getAllType();
        this.titleLists = res.map((item) => ({
          name: item.TypeName || item.Type,
          value: item.Type,
          count: item.amount,
        }));
        this.titleLists.unshift({
          name: '全部待办',
          value: '',
          count: this.titleLists.reduce((res, item) => parseInt(item.count) + res, 0),
        });
        sessionStorage.setItem('titleLists', JSON.stringify(this.titleLists));
      } catch (e) {
        console.log(e);
      }
    },

    //点击品类进行过滤接口
    async getTicketByType(i, searchStr) {
      const { value } = this.titleLists[i || 0]  || {value: ''};
      this.$router.replace({ path: '/todo', query: { num: i, key: searchStr } });
      this.Type = value;
      this.loading = true;
      this.searchStr = searchStr;
      try {
        const { List, TotalRows } = await getOtobTicket({
          Type: value,
        });
        this.ticketList = List.map((item) => ({
          ...item,
          TodoDesc: this.parseJson(item.TodoDesc || '[]'),
        }));
        this.activeName = this.ticketList.map((item) => item?.TaskId || item?.TaskOrderId);
        console.log(this.ticketList);
        this.total = TotalRows;
        this.titleLists[i || 0].count = TotalRows;
      } catch (e) {
        this.$toast(e);
      } finally {
        this.loading = false;
        sessionStorage.setItem('titleLists', JSON.stringify(this.titleLists));
      }
    },

    parseJson(json) {
      try {
        return JSON.parse(json);
      } catch (e) {
        return [];
      }
    },

    // 工单详情页
    gotoDetail(item) {
      // 单独取出工单类型
      this.loading = true;
      
      // let url = '';
      if (!item.TaskId) {
        console.log('走1');
        this.$router.push({
          path: '/' + item.Type,
          query: { Id: item.TaskOrderId },
        });
      } else {
        console.log(this.searchStr, '走2');
        this.$router.push({
          path: '/todo-detail',
          query: { ticketId: item.TicketId, taskId: item.TaskId, key: this.searchStr },
        });
      }
      // location.href = url.href;
    },
    // 触底加载
    async onLoad() {
      if (this.refreshing) {
        this.lists = [];
        this.refreshing = false;
      }
      await this.getTicketByType(this.sidebarNum);
      this.finished = true;
    },
    async onRefresh() {
      // 清空列表数据
      this.finished = false;
      await this.onLoad();
    },

    // 语音识别完成处理
    handleVoiceRecognition(recognitionText) {
      console.log('[TodoPage] 语音识别完成:', recognitionText);
      
      // 如果有待打开的工单，说明正在进行语音确认流程
      if (this.pendingTicketToOpen) {
        console.log('[TodoPage] 检测到语音确认流程，处理用户响应');
        this.handleVoiceConfirmationResponse(recognitionText);
        return;
      }
      
      // 可以在这里处理语音识别结果，比如自动搜索
      // if (recognitionText && recognitionText.trim()) {
      //   // 自动将识别结果填入搜索框并搜索
      //   this.searchValue = recognitionText.trim();
      //   this.checkSearch(recognitionText.trim());
      // }
    },

    // 处理tickets响应（混元API返回的工单列表）
    async handleTicketResponse(data) {
      this.searchStr = ''
          
      try {
        console.log('[TodoPage] 处理tickets响应:', data);
        
        // 检查深度搜索是否已被取消
        if (this.deepSearchCancelled) {
          console.log('[TodoPage] 深度搜索已被取消，忽略响应');
          return;
        }
        
        // 关闭深度搜索Dialog（如果存在）
        if (this.deepSearchToast) {
          this.deepSearchToast = null;
          Dialog.close();
        }
        this.isDeepSearching = false;
        
        const { tickets, params, query } = data;
        
        // // 如果有query参数，将其展示在搜索框
        // if (query) {
        //   this.searchValue = query;
        //   this.searchStr = query;
        //   this.hasSearch = false; // 显示搜索框
          
        //   // 更新路由，保留搜索关键词
        //   this.$router.replace({ 
        //     path: '/todo', 
        //     query: { 
        //       num: this.sidebarNum || 0, 
        //       search: query 
        //     } 
        //   });
        // }
        
        // 情况1: tickets为空
        if (!tickets || tickets.length === 0) {
          console.log('[TodoPage] tickets为空，没有搜到待办');
          
          // 清空待办列表
          this.ticketList = [];
          this.total = 0;
          
          // 显示提示
          const message = params || '没有搜到匹配的待办';
          this.$toast({
            message,
            type: 'warning',
            duration: 3000
          });
          
          this.checkSearch('')
          // 播放语音提示
          this.speakText(message);
          
          // 关闭AI对话框
          this.closeVoiceAssistant();
          return;
        }
        
        // 情况2: tickets只有一条数据，直接跳转
        if (tickets.length === 1) {
          console.log('[TodoPage] tickets只有一条，直接跳转');
          
          const ticket = tickets[0];
          
          // 上报语音助手自动打开工单日志
          try {
            const { aegis } = this.$store.state.user;
            if (aegis) {
              aegis.infoAll({
                msg: JSON.stringify({
                  action: 'voice_auto_open_todo',
                  source: 'voice_assistant',
                  taskId: ticket.TaskId || ticket.TaskOrderId,
                  ticketId: ticket.TicketId,
                  type: ticket.Type,
                  typeName: ticket.TypeName,
                  title: ticket.TodoName || ticket.TitleContent,
                  isUrgent: ticket.IsUrgent,
                  voiceQuery: query || this.lastUserVoiceQuery,
                  timestamp: new Date().toISOString()
                }),
                ext1: 'voice-auto-open-todo',
                trace: 'voice-open-todo',
              });
            }
          } catch (reportError) {
            console.error('[TodoPage] 上报语音自动打开工单日志失败:', reportError);
          }
          
          // 显示提示
          const message = params || '已找到待办，即将自动打开...';
          this.$toast({
            message,
            type: 'success',
            duration: 500
          });
          
          // 0.5秒后自动跳转
          setTimeout(() => {
            this.gotoDetail(ticket);
            // 关闭AI对话框
            this.closeVoiceAssistant();
          }, 500);
          return;
        }
        
        // 情况3: tickets包含多条数据
        if (tickets.length > 1) {
          console.log(`[TodoPage] tickets包含${tickets.length}条数据，展示列表`);
          
          // 需要通过API获取完整的待办信息来展示
          this.loading = true;

          
          try {
            // 提取所有的TaskId
            const taskIds = tickets.map(t => t.TaskId).filter(Boolean);
            
            if (taskIds.length > 0) {
              // 通过TaskId批量查询待办详情
              // 这里假设可以通过关键词搜索来获取这些待办
              // 如果有专门的批量查询API，应该使用那个API
              // const { List } = await getOtobTicket({
              //   Type: this.Type,
              //   KeyWords: query || '',
              // });
          const List = this.promptList || [];

              
              // 过滤出匹配的待办
              const matchedTickets = List.filter(item => 
                taskIds.includes(item.TaskId) || taskIds.includes(item.TaskOrderId)
              );
              
              // 如果过滤后有结果，使用过滤结果；否则使用全部搜索结果
              const displayTickets = matchedTickets.length > 0 ? matchedTickets : List;
              
              // 展示待办列表
              this.ticketList = displayTickets.map((item) => ({
                ...item,
                TodoDesc: this.parseJson(item.TodoDesc || '[]'),
              }));
              this.activeName = this.ticketList.map((item) => item?.TaskId || item?.TaskOrderId);
              this.total = this.ticketList.length;
              
              // 上报语音搜索返回多条结果日志
              try {
                const { aegis } = this.$store.state.user;
                if (aegis) {
                  aegis.infoAll({
                    msg: JSON.stringify({
                      action: 'voice_search_multiple_results',
                      source: 'voice_assistant',
                      voiceQuery: query || this.lastUserVoiceQuery,
                      resultCount: this.ticketList.length,
                      ticketsCount: tickets.length,
                      timestamp: new Date().toISOString(),
                      results: this.ticketList.slice(0, 5).map(item => ({
                        taskId: item.TaskId || item.TaskOrderId,
                        ticketId: item.TicketId,
                        type: item.Type,
                        typeName: item.TypeName,
                        title: item.TodoName || item.TitleContent,
                        isUrgent: item.IsUrgent
                      }))
                    }),
                    ext1: 'voice-search-multiple-todo',
                    trace: 'voice-search-todo',
                  });
                }
              } catch (reportError) {
                console.error('[TodoPage] 上报语音搜索多条结果日志失败:', reportError);
              }
              
            } else {
              // 如果没有TaskId，直接展示tickets数据（可能需要格式转换）
              this.ticketList = tickets.map((item) => ({
                ...item,
                TodoDesc: this.parseJson(item.TodoDesc || '[]'),
              }));
              this.activeName = this.ticketList.map((item) => item?.TaskId || item?.TaskOrderId);
              this.total = tickets.length;
              
              // 上报语音搜索返回多条结果日志
              try {
                const { aegis } = this.$store.state.user;
                if (aegis) {
                  aegis.infoAll({
                    msg: JSON.stringify({
                      action: 'voice_search_multiple_results',
                      source: 'voice_assistant',
                      voiceQuery: query || this.lastUserVoiceQuery,
                      resultCount: this.ticketList.length,
                      ticketsCount: tickets.length,
                      timestamp: new Date().toISOString(),
                      results: this.ticketList.slice(0, 5).map(item => ({
                        taskId: item.TaskId || item.TaskOrderId,
                        ticketId: item.TicketId,
                        type: item.Type,
                        typeName: item.TypeName,
                        title: item.TodoName || item.TitleContent,
                        isUrgent: item.IsUrgent
                      }))
                    }),
                    ext1: 'voice-search-multiple-todo',
                    trace: 'voice-search-todo',
                  });
                }
              } catch (reportError) {
                console.error('[TodoPage] 上报语音搜索多条结果日志失败:', reportError);
              }
            }
            
            // 显示提示消息
            const message = params || `共为你找到${tickets.length}条可能的工单数据，请选择`;
            this.$toast({
              message,
              type: 'warning',
              duration: 3000
            });
            
            // 播放提示音
            this.playNotificationSound();
            
            // 播放语音提示
            this.speakText(message);
            
          } catch (error) {
            console.error('[TodoPage] 获取待办详情失败:', error);
            
            // 显示错误提示
            this.$toast({
              message: '获取待办详情失败',
              type: 'fail',
              duration: 2000
            });
          } finally {
            this.loading = false;
          }
          
          // 关闭AI对话框
          this.closeVoiceAssistant();
          return;
        }
        
      } catch (error) {
        console.error('[TodoPage] 处理tickets响应失败:', error);
        
        this.$toast({
          message: '处理响应失败',
          type: 'fail',
          duration: 2000
        });
        
        // 关闭AI对话框
        this.closeVoiceAssistant();
      }
    },

    // AI接口响应处理
    handleAIResponse(data) {
      console.log('[TodoPage] AI接口响应:', data);
      
      // 保存用户的完整语音输入（用于后续可能的重新调用）
      if (data?.query) {
        this.lastUserVoiceQuery = data.query;
        console.log('[TodoPage] 保存用户语音输入:', this.lastUserVoiceQuery);
      }
      
      try {
        // 解析AI响应数据
        let aiResult = data?.result;
        if (typeof aiResult === 'string') {
          aiResult = JSON.parse(aiResult);
        }
        
        // 进一步解析嵌套的JSON
        if (aiResult?.data?.data?.result) {
          const resultStr = aiResult.data.data.result;
          if (typeof resultStr === 'string') {
            aiResult = JSON.parse(resultStr);
          } else {
            aiResult = resultStr;
          }
        }
        
        console.log('[TodoPage] 解析后的AI结果:', aiResult);
        
        // 优先检查是否包含tickets字段（新的响应格式）
        if (aiResult && aiResult.tickets && aiResult.tickets.length > 0) {
          // 处理tickets响应格式
          this.handleTicketResponse({
            tickets: aiResult.tickets,
            params: aiResult.params,
            query: data.query || this.lastUserVoiceQuery
          });
        } else if (aiResult && aiResult.tool && !aiResult.ask) {
          // 检查是否包含tool和params字段（原有的工具调用格式）
          this.executeAITool(aiResult.tool, aiResult.params);
        } else {
          // 如果没有工具调用，显示通用成功消息
        }
        
      } catch (error) {
        console.error('[TodoPage] 解析AI响应失败:', error);
        this.$toast({
          message: 'AI响应解析失败',
          type: 'fail',
          duration: 2000
        });
      }
    },

    // 执行AI工具调用
    executeAITool(tool, params) {
      console.log(`[TodoPage] 执行AI工具: ${tool}`, params);
      
      // 在执行所有工具前，先切换到第0个tab（全部待办）
      // 排除某些特殊工具：switchType（本身就是切换tab）、closeAI（关闭助手）
      const toolsNoNeedSwitch = ['switchType', 'closeAI'];
      if (!toolsNoNeedSwitch.includes(tool)) {
        console.log('[TodoPage] 执行指令前切换到全部待办tab');
        this.sidebarNum = 0;
        this.Type = '';
        
        // 同步更新URL参数
        this.$router.replace({ 
          path: '/todo', 
          query: { 
            num: 0
          } 
        }).catch(err => {
          // 忽略导航重复错误
          if (err.name !== 'NavigationDuplicated') {
            console.error('[TodoPage] 更新路由失败:', err);
          }
        });
      }
      
      // 工具调用映射表
      const toolHandlers = {
        // 搜索工单
        search: this.handleSearchTool,
        // 筛选工单类型
        filter: this.handleFilterTool,
        // 跳转到详情页
        navigate: this.handleNavigateTool,
        // 刷新列表
        refresh: this.handleRefreshTool,
        // 切换侧边栏
        switchType: this.handleSwitchTypeTool,
        // 展开/折叠侧边栏
        toggleSidebar: this.handleToggleSidebarTool,
        // 打开待办详情
        openTicket: this.handleOpenTicketTool,
        // 关闭/隐藏语音助手
        closeAI: this.handleCloseTool,
        // ping值工具搜索
        pingTool: this.handleOpenPingTool,
        // 跨页面跳转
        diffPages: this.handleDiffPages
      };
      
      // 获取对应的处理函数
      const handler = toolHandlers[tool];
      
      if (handler && typeof handler === 'function') {
        try {
          // 调用对应的处理函数
          handler.call(this, params);
          
          // openTicket 工具不自动关闭弹窗和显示提示
          // 因为它需要根据搜索结果来决定后续操作
          if (tool !== 'openTicket') {
            // 关闭语音助手弹窗
            this.closeVoiceAssistant();
            
            // 显示执行成功消息
            const toolDisplayName = this.getToolDisplayName(tool);
            // this.$toast({
            //   message: `已执行指令：${toolDisplayName}`,
            //   type: 'success',
            //   duration: 3000
            // });
          }
          
        } catch (error) {
          console.error(`[TodoPage] 执行工具 ${tool} 失败:`, error);
          
          // 关闭语音助手弹窗
          this.closeVoiceAssistant();
          
          // 显示执行失败消息
          const toolDisplayName = this.getToolDisplayName(tool);
          this.$toast({
            message: `执行指令失败：${toolDisplayName} - ${error.message || '未知错误'}`,
            type: 'fail',
            duration: 3000
          });
        }
      } else {
        console.warn(`[TodoPage] 未知的工具类型: ${tool}`);
        
        // 关闭语音助手弹窗
        this.closeVoiceAssistant();
        
        // 显示不支持的工具类型错误提示
        this.$toast({
          message: `错误：不支持的指令类型 "${tool}"，请尝试其他指令`,
          type: 'fail',
          duration: 3000
        });
      }
    },

    // 关闭语音助手弹窗
    closeVoiceAssistant() {
      // 通过ref调用语音助手组件的关闭方法
      if (this.$refs.voiceAssistant) {
        this.$refs.voiceAssistant.closeVoiceModal();
      }
    },

    // 获取工具显示名称
    getToolDisplayName(tool) {
      const displayNames = {
        search: '搜索',
        filter: '筛选',
        navigate: '跳转',
        refresh: '刷新',
        switchType: '切换类型',
        toggleSidebar: '切换侧边栏',
        openTicket: '打开待办',
        closeAI: '关闭语音助手',
      };
      return displayNames[tool] || tool;
    },

    // 处理搜索工具
    async handleSearchTool(params) {
      const { keyword, keywords } = params;
      const searchKeyword = keyword || keywords;
      
      if (!searchKeyword) {
        throw new Error('搜索关键词不能为空');
      }

      console.log(`[TodoPage] 执行搜索: ${searchKeyword}`);

      // 将关键字同步到搜索框并展示
      this.searchValue = searchKeyword;
      this.searchStr = searchKeyword;
      this.hasSearch = false; // 展示搜索框

      try {
        // 1. 执行关键词搜索
        this.loading = true;
        const { List, TotalRows } = await getOtobTicket({
          Type: this.Type,
          KeyWords: searchKeyword,
        });

        console.log(`[TodoPage] 搜索到 ${List.length} 条待办记录`);

        // 更新路由，保留搜索关键词
        this.$router.replace({ 
          path: '/todo', 
          query: { 
            num: this.sidebarNum || 0, 
            search: searchKeyword 
          } 
        });

        // 2. 根据搜索结果数量执行不同操作
        if (List.length === 0) {
          // 没有搜到待办
          // 检查是否是通过keywords参数传入的（说明是混元API返回的关键词）
          // const isFromKeywords = params.hasOwnProperty('keywords');
          await this.handleNoTicketFound(searchKeyword, true);
        } else {
      sessionStorage.setItem('key', searchKeyword || '')
          // 搜到待办，显示搜索结果
          this.ticketList = List.map((item) => ({
            ...item,
            TodoDesc: this.parseJson(item.TodoDesc || '[]'),
          }));
          this.activeName = this.ticketList.map((item) => item?.TaskId || item?.TaskOrderId);
          this.total = TotalRows;

          // 显示成功提示
          this.$toast({
            message: `搜到 ${List.length} 条待办`,
            type: 'success',
            duration: 2000
          });

          // 关闭语音助手弹窗
          this.closeVoiceAssistant();
        }

      } catch (error) {
        console.error('[TodoPage] 搜索待办失败:', error);
        this.$toast({
          message: '搜索待办失败，请重试',
          type: 'fail',
          duration: 2000
        });
        this.closeVoiceAssistant();
      } finally {
        this.loading = false;
      }
    },

    // 处理打开待办工具
    async handleOpenTicketTool(params) {
      const { keyword, keywords } = params;
      const searchKeyword = keyword || keywords;
      
      if (!searchKeyword) {
        throw new Error('搜索关键词不能为空');
      }

      console.log(`[TodoPage] 执行打开待办: ${searchKeyword}`);

      // 将关键字同步到搜索框并展示
      this.searchValue = searchKeyword;
      this.searchStr = searchKeyword;
      this.hasSearch = false; // 展示搜索框

      try {
        // 1. 执行关键词搜索
        this.loading = true;
        const { List, TotalRows } = await getOtobTicket({
          Type: this.Type,
          KeyWords: searchKeyword,
        });

        console.log(`[TodoPage] 搜索到 ${List.length} 条待办记录`);

        // 2. 根据搜索结果数量执行不同操作
        if (List.length === 0) {
          // 情况3: 没有搜到待办
          // 检查是否是通过keywords参数传入的（说明是混元API返回的关键词）
          // const isFromKeywords = params.hasOwnProperty('keywords');
          await this.handleNoTicketFound(searchKeyword, true);
        } else if (List.length === 1) {
      sessionStorage.setItem('key', searchKeyword || '')

          // 情况1: 仅搜到1条待办记录
          this.handleSingleTicketFound(List[0], searchKeyword);
        } else {
      sessionStorage.setItem('key', searchKeyword || '')

          // 情况2: 搜到多条待办记录
          this.handleMultipleTicketsFound(List.length, searchKeyword);
        }

      } catch (error) {
        console.error('[TodoPage] 打开待办失败:', error);
        this.$toast({
          message: '搜索待办失败，请重试',
          type: 'fail',
          duration: 2000
        });
        this.closeVoiceAssistant();
      } finally {
        this.loading = false;
      }
    },

        // 使用待办列表信息重新调用混元API（供外部调用）
    async retryWithTicketList(userQuery, ticketListInfo) {
      try {
        console.log('[VoiceAssistant] 使用待办列表信息重新调用混元API');
        console.log('[VoiceAssistant] 用户查询:', userQuery);
        console.log('[VoiceAssistant] 待办列表数量:', ticketListInfo.length);
        
        // 设置API处理状态
        this.isApiProcessing = true;
        this.statusText = 'AI正在重新分析中...';
        
        // 准备对话参数，包含待办列表上下文
        const conversationParams = {
          context: JSON.stringify({
            TicketList: ticketListInfo
          })
        };
        
        console.log('[VoiceAssistant] 传入待办列表上下文:', conversationParams);
        
        // 调用postHunyuan函数，传入用户查询、ForwardService和待办列表上下文
        const result = await postHunyuan(userQuery, 'hyaide-application-20082', conversationParams);
        
        console.log('[VoiceAssistant] 混元API重新分析结果:', JSON.parse(result?.data?.data?.result));
        
        // 上报日志
        const { aegis } = this.$store.state.user;
        if (aegis) {
          aegis.infoAll({
            msg: JSON.stringify({
              action: 'retry-with-ticket-list',
              query: userQuery,
              ticketCount: ticketListInfo.length,
              result: result?.data?.data?.result
            }),
            ext1: 'voice-assistant-retry',
            trace: 'voice-assistant-retry-with-ticket-list',
          });
        }
        
        const parsedResult = JSON.parse(result?.data?.data?.result);
        
        // 清除API处理状态
        this.isApiProcessing = false;
        this.statusText = '';
        
        this.$emit('change', {...parsedResult, query: userQuery});
        
        console.log('[VoiceAssistant] 重新分析完成，已发出事件');
        
      } catch (error) {
        console.error('[VoiceAssistant] 使用待办列表重新调用混元API失败:', error);
        
        // 清除API处理状态
        this.isApiProcessing = false;
        this.statusText = '';
        
        // 上报错误
        try {
          const { aegis } = this.$store.state.user;
          if (aegis) {
            aegis.infoAll({
              msg: JSON.stringify({
                type: 'retry_with_ticket_list_error',
                query: userQuery,
                error: error.message || error.toString(),
                stack: error.stack,
                timestamp: new Date().toISOString()
              }),
              ext1: 'voice-assistant-error',
              trace: 'retry-with-ticket-list-error',
            });
          }
        } catch (reportError) {
          console.error('[VoiceAssistant] 上报错误失败:', reportError);
        }
        
        // 显示错误提示
        this.$toast({
          message: 'AI重新分析失败，请重试',
          type: 'fail',
          duration: 3000
        });
        
        // 发出错误事件
        this.$emit('ai-error', {
          query: userQuery,
          error
        });
      }
    },

    // 处理单条待办的情况
    handleSingleTicketFound(ticket, keyword) {
      console.log('[TodoPage] 找到单条待办，0.5秒后自动跳转');
      
      // 显示搜索结果
      this.ticketList = [ticket].map((item) => ({
        ...item,
        TodoDesc: this.parseJson(item.TodoDesc || '[]'),
      }));
      this.activeName = this.ticketList.map((item) => item?.TaskId || item?.TaskOrderId);
      
      // 更新路由，保留搜索关键词
      if (keyword) {
        this.$router.replace({ path: '/todo', query: { num: this.sidebarNum || 0, search: keyword } });
      }
      
      // 显示提示
      this.$toast({
        message: '已找到待办，即将自动打开...',
        type: 'success',
        duration: 500
      });

      // 0.5秒后自动跳转
      setTimeout(() => {
        this.gotoDetail(ticket);
        this.closeVoiceAssistant();
      }, 500);
    },

    // 处理多条待办的情况
    handleMultipleTicketsFound(count, keyword) {
      console.log(`[TodoPage] 找到 ${count} 条待办，需要用户手动选择`);
      
      // 显示搜索结果（关键字已在 handleOpenTicketTool 中同步到搜索框）
      // 重新执行搜索以显示完整的搜索结果列表
      this.checkSearch(keyword);
      
      // 显示提示消息
      const message = `搜到${count}条符合条件的待办，请手动选择需要打开的待办`;
      this.$toast({
        message,
        type: 'warning',
        duration: 3000
      });

      // 播放提示音
      this.playNotificationSound();

      // 播放语音提示
      this.speakText(message);

      // 关闭语音助手弹窗
      this.closeVoiceAssistant();
    },

    // 处理没有找到待办的情况
    async handleNoTicketFound(keyword, isFromKeywords = false) {
      console.log('[TodoPage] 没有搜到匹配的待办', { keyword, isFromKeywords });
      
      // 将关键词同步到搜索框（已在 handleOpenTicketTool 中同步）
      // 更新路由，保留搜索关键词
      this.$router.replace({ 
        path: '/todo', 
        query: { 
          num: this.sidebarNum || 0, 
          search: keyword 
        } 
      });
      
      // 清空待办列表，显示空状态
      this.ticketList = [];
      this.total = 0;
      
      // 如果是通过keywords查询且结果为空，则再次调用混元API
      if (isFromKeywords) {
        console.log('[TodoPage] 通过keywords查询结果为空，准备再次调用混元API');
        
        // 切换到第0个tab（全部待办），确保深度搜索时Type为空字符串
        this.sidebarNum = 0;
        this.Type = '';
        console.log('[TodoPage] 已切换到全部待办分类，Type:', this.Type);
        
        // 更新路由
        // this.$router.replace({ 
        //   path: '/todo', 
        //   query: { 
        //     num: 0, 
        //     search: keyword 
        //   } 
        // });
        
        // 设置深度搜索状态
        this.isDeepSearching = true;
        this.deepSearchCancelled = false;
        
        // 显示提示消息，带取消按钮
        this.deepSearchToast = Dialog.alert({
          title: 'AI深度搜索',
          message: '正在进行深度搜索，请稍候...',
          showCancelButton: true,
          cancelButtonText: '取消搜索',
          confirmButtonText: '',
          showConfirmButton: false,
          closeOnClickOverlay: false,
          beforeClose: (action, done) => {
            if (action === 'cancel') {
              this.cancelDeepSearch();
              done();
            } else {
              done();
            }
          }
        });
        
        // 保持录音弹框可见，不关闭语音助手
        // 获取完整的待办列表（前100条）
        // 注意：此时Type已经是空字符串，会获取所有类型的待办
        try {
          const { List } = await getOtobTicket({
            Type: this.Type, // 此时Type为空字符串，获取全部待办
            Size: 100,
            Start: 1
          });
          this.promptList = List;
          
          // 检查是否已被取消
          if (this.deepSearchCancelled) {
            console.log('[TodoPage] 深度搜索已被用户取消');
            return;
          }
          
          console.log(`[TodoPage] 获取到 ${List.length} 条待办记录，准备传递给混元API`);
          
          // 通过ref调用语音助手组件的方法，再次发起混元API调用
          if (this.$refs.voiceAssistant) {
            // 使用保存的用户完整语音输入
            const userQuery = this.lastUserVoiceQuery || keyword;
            console.log('[TodoPage] 使用用户语音输入:', userQuery);
            
            // 准备待办列表信息
            const ticketListInfo = List.map(item => ({
              ...item,
              TaskId: item.TaskId || item.TaskOrderId,
              TodoName: item.TodoName || item.TitleContent,
              TypeName: item.TypeName || item.Type,
              IsUrgent: item.IsUrgent,
              TodoDesc: item.TodoDesc
            }));
            
            // 调用语音助手组件的方法，再次发起混元API调用
            await this.$refs.voiceAssistant.retryWithTicketList(userQuery, JSON.stringify(ticketListInfo));
            
            // 深度搜索完成，关闭Dialog
            if (this.deepSearchToast) {
              this.deepSearchToast = null;
              Dialog.close();
            }
            this.isDeepSearching = false;
          }
        } catch (error) {
          console.error('[TodoPage] 获取待办列表失败:', error);
          
          // 关闭深度搜索Dialog
          if (this.deepSearchToast) {
            this.deepSearchToast = null;
            Dialog.close();
          }
          this.isDeepSearching = false;
          
          // 显示错误提示
          const errorMessage = `没有搜到匹配"${keyword}"的待办，请重新输入关键词`;
          this.$toast({
            message: errorMessage,
            type: 'warning',
            duration: 3000
          });
          this.checkSearch()
          // 播放语音提示
          this.speakText(errorMessage);
        }
      } else {
        // 普通情况：显示文字提示
        const message = `没有搜到匹配"${keyword}"的待办，请重新输入关键词`;
        this.$toast({
          message,
          type: 'warning',
          duration: 3000
        });
          this.checkSearch()


        // 播放语音提示
        this.speakText(message);

        // 不关闭语音助手弹框，保持打开状态，用户可以继续使用
        console.log('[TodoPage] 已显示文字和语音提示，语音助手弹框保持打开');
      }
    },

    // 播放提示音
    playNotificationSound() {
      try {
        // 创建音频上下文
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);

        // 设置音调和音量
        oscillator.frequency.value = 800; // 频率 800Hz
        gainNode.gain.value = 0.3; // 音量 30%

        // 播放 0.2 秒
        oscillator.start(audioContext.currentTime);
        oscillator.stop(audioContext.currentTime + 0.2);

        console.log('[TodoPage] 播放提示音');
      } catch (error) {
        console.error('[TodoPage] 播放提示音失败:', error);
      }
    },

    // 使用Web Speech API播放语音
    speakText(text) {
      try {
        // 检查浏览器是否支持Web Speech API
        if (!('speechSynthesis' in window)) {
          console.warn('[TodoPage] 浏览器不支持Web Speech API');
          return;
        }

        // 停止当前正在播放的语音
        window.speechSynthesis.cancel();

        // 创建语音合成实例
        const utterance = new SpeechSynthesisUtterance(text);
        
        // 设置语音参数
        utterance.lang = 'zh-CN'; // 中文
        utterance.rate = 1.0; // 语速（0.1-10，默认1）
        utterance.pitch = 1.0; // 音调（0-2，默认1）
        utterance.volume = 1.0; // 音量（0-1，默认1）

        // 监听事件
        utterance.onstart = () => {
          console.log('[TodoPage] 开始播放语音:', text);
        };

        utterance.onend = () => {
          console.log('[TodoPage] 语音播放完成');
        };

        utterance.onerror = (event) => {
          console.error('[TodoPage] 语音播放错误:', event.error);
        };

        // 播放语音
        window.speechSynthesis.speak(utterance);
      } catch (error) {
        console.error('[TodoPage] 播放语音失败:', error);
      }
    },

    // 跨页面跳转
    async handleDiffPages(params) {
      const { name, path } = params;
      console.log(`[path] 跨页面跳转执行筛选: ${name}, ${path}`);

      if (path) {
        // 直接跳转到指定路径
        this.$router.push(path);
      } else {
        throw new Error('未找到对应页面');
      }

    },

    // 处理ping固资筛选
    async handleOpenPingTool(params) {
      const { assetId } = params;
      console.log(`[TodoPage] 执行筛选: ${assetId}`);

      try {
        // 1. 更新搜索框
        this.searchValue = assetId;
        this.searchStr = assetId;
        this.hasSearch = false; // 展示搜索框

        // 2. 搜索工单
        this.loading = true;
        const { List, TotalRows } = await getOtobTicket({
          Type: this.Type,
          KeyWords: assetId,
        });

        // 3. 更新待办列表
        if (List && List.length > 0) {
          this.ticketList = List.map((item) => ({
            ...item,
            TodoDesc: this.parseJson(item.TodoDesc || '[]'),
          }));
          this.activeName = this.ticketList.map((item) => item?.TaskId || item?.TaskOrderId);
          this.total = TotalRows;

          // 更新路由，保留搜索关键词
          this.$router.replace({ 
            path: '/todo', 
            query: { 
              num: this.sidebarNum || 0, 
              search: assetId 
            } 
          });

          // 4. 提取工单号和固资信息
          const ticket = List[0];
          const todoDesc = this.parseJson(ticket.TodoDesc || '[]');
          const ticketNo = todoDesc.find(item => item.key === '工单号')?.value;
          const asset = todoDesc.find(item => item.key === '固资')?.value;
          
          if (ticketNo && asset) {
            console.log(`[TodoPage] 提取到工单号: ${ticketNo}, 固资: ${asset}`);
            
            // 5. 调用getPingTodoData方法
            const pingParams = {
              ticketId: ticketNo,
              search: asset,
            };
            const result = await getPingTodoData(pingParams);

            // 6. 检查返回结果
            if (result && result.status === 0 && result.data && result.data.taskId) {
              console.log(`[TodoPage] 成功获取到taskId: ${result.data.taskId}`);

              // 7. 保存工单信息供后续确认使用
              this.pendingTicketToOpen = {
                TicketId: ticketNo,
                TaskId: this.ticketList?.[0]?.TaskId,
                Type: ticket.Type,
                TodoName: ticket.TodoName,
                TodoDesc: ticket.TodoDesc,
                asset: asset,
              };

              // 8. 进入对话模式进行二次确认
              this.startVoiceConfirmation(asset, result.data.taskId);

            } else {
              console.warn('[TodoPage] 未成功获取到taskId或返回状态异常');
              this.$toast({
                message: result?.msg || '获取工单信息失败',
                type: 'warning',
                duration: 3000,
              });
              this.closeVoiceAssistant();
            }

          } else {
            console.warn('[TodoPage] 未找到工单号或固资信息');
            this.$toast({
              message: '未找到工单号或固资信息',
              type: 'warning',
              duration: 3000
            });
            this.closeVoiceAssistant();
          }
        } else {
          console.warn('[TodoPage] 未找到匹配的待办记录');
          this.$toast({
          message: '未找到匹配的待办记录',
          type: 'warning',
          duration: 3000
        });
        this.closeVoiceAssistant();
      }
      } catch (error) {
        console.error('[TodoPage] pingTool执行失败:', error);
        this.$toast({
          message: '操作失败，请重试',
          type: 'fail',
          duration: 3000
        });
        this.closeVoiceAssistant();
      } finally {
        this.loading = false;
      }
    },

    // 开始语音确认流程
    startVoiceConfirmation(asset, taskId) {
      console.log('[TodoPage] 开始语音确认流程');
      
      // 确保语音助手处于对话模式
      if (this.$refs.voiceAssistant) {
        // 切换到对话模式
        this.$refs.voiceAssistant.switchToConversationMode();
        
        // 构建确认消息
        const confirmMessage = `执行Ping任务成功，任务ID为 ${taskId}。\n已自动关联固资号 ${asset} 对应的工单，是否确认打开工单？`;
        
        // 添加到对话历史
        this.$refs.voiceAssistant.addAssistantMessage(confirmMessage);
        
        // 播放语音提示
        this.speakTextAndStartRecording('执行任务成功，是否要打开关联的工单？');
      }
    },

    // 播放语音并在完成后自动开始录音（使用语音助手组件的方法）
    speakTextAndStartRecording(text) {
      console.log('[TodoPage] 播放语音并准备录音:', text);
      
      // 直接使用语音助手组件的 speakText 方法
      // 该方法在对话模式下会自动在播报结束后播放提示音并开始录音
      if (this.$refs.voiceAssistant) {
        this.$refs.voiceAssistant.speakText(text);
      }
    },

    // 处理语音确认响应
    handleVoiceConfirmationResponse(userInput) {
      console.log('[TodoPage] 处理语音确认响应:', userInput);
      
      if (!this.pendingTicketToOpen) {
        console.warn('[TodoPage] 没有待打开的工单信息');
        return;
      }

      // 检查用户输入是否包含确认关键词
      const confirmKeywords = ['确认', '确定', '是的', '是', '好的', '好', '打开', 'ok', 'OK'];
      const cancelKeywords = ['取消', '不', '不要', '不用', '算了'];
      
      const isConfirm = confirmKeywords.some(keyword => userInput.includes(keyword));
      const isCancel = cancelKeywords.some(keyword => userInput.includes(keyword));

      if (isConfirm && !isCancel) {
        // 用户确认打开工单
        console.log('[TodoPage] 用户确认打开工单');
        
        // 立即停止录音（如果正在录音）
        if (this.$refs.voiceAssistant) {
          this.$refs.voiceAssistant.stopRecordingImmediately();
        }
        
        // 跳转到工单详情页
        this.gotoDetail(this.pendingTicketToOpen);
        
        // 显示成功提示
        this.$toast({
          message: '正在打开工单...',
          type: 'success',
          duration: 1000,
        });

        // 关闭语音助手
        this.closeVoiceAssistant();
        
        // 清空待打开的工单信息
        this.pendingTicketToOpen = null;
        
      } else if (isCancel) {
        // 用户取消操作
        console.log('[TodoPage] 用户取消打开工单');
        
        // 立即停止录音（如果正在录音）
        if (this.$refs.voiceAssistant) {
          this.$refs.voiceAssistant.stopRecordingImmediately();
        }
        
        this.$toast({
          message: '已取消打开工单',
          type: 'info',
          duration: 2000,
        });

        // 关闭语音助手
        this.closeVoiceAssistant();
        
        // 清空待打开的工单信息
        this.pendingTicketToOpen = null;
        
      } else {
        // 无法识别用户意图，再次询问
        console.log('[TodoPage] 无法识别用户意图，再次询问');
        
        const retryMessage = '抱歉，我没有理解您的意思。请说"确认"打开工单，或说"取消"放弃操作。';
        
        if (this.$refs.voiceAssistant) {
          this.$refs.voiceAssistant.addAssistantMessage(retryMessage);
          this.speakTextAndStartRecording(retryMessage);
        }
      }
    },

    // 处理筛选工具
    handleFilterTool(params) {
      const { type, typeName } = params;
      console.log(`[TodoPage] 执行筛选: ${type || typeName}`);
      
      // 根据类型名称或类型值查找对应的索引
      let targetIndex = -1;
      if (type) {
        targetIndex = this.titleLists.findIndex(item => item.value === type);
      } else if (typeName) {
        targetIndex = this.titleLists.findIndex(item => item.name === typeName);
      }
      
      if (targetIndex !== -1) {
        this.sidebarNum = targetIndex;
        this.getWhereType();
      } else {
        throw new Error(`未找到匹配的工单类型: ${type || typeName}`);
      }
    },

    // 处理导航工具
    handleNavigateTool(params) {
      const { taskId, ticketId, type, path } = params;
      console.log(`[TodoPage] 执行导航:`, params);
      
      if (path) {
        // 直接跳转到指定路径
        this.$router.push(path);
      } else if (taskId && ticketId) {
        // 跳转到工单详情页
        this.$router.push({
          path: '/todo-detail',
          query: { ticketId, taskId, key: this.searchStr },
        });
      } else if (type) {
        // 跳转到指定类型页面
        this.$router.push({
          path: '/' + type,
        });
      } else {
        throw new Error('导航参数不完整');
      }
    },

    // 处理刷新工具
    handleRefreshTool(params) {
      console.log(`[TodoPage] 执行刷新`);
      this.onRefresh();
    },

    // 处理切换类型工具
    handleSwitchTypeTool(params) {
      const { index, type, typeName } = params;
      console.log(`[TodoPage] 执行切换类型:`, params);
      
      let targetIndex = index;
      
      // 如果没有提供索引，根据类型或名称查找
      if (targetIndex === undefined) {
        if (type) {
          targetIndex = this.titleLists.findIndex(item => item.value === type);
        } else if (typeName) {
          targetIndex = this.titleLists.findIndex(item => item.name === typeName);
        }
      }
      
      if (targetIndex !== undefined && targetIndex >= 0 && targetIndex < this.titleLists.length) {
        this.sidebarNum = targetIndex;
        this.getWhereType();
      } else {
        throw new Error('无效的类型索引或类型名称');
      }
    },

    // 处理切换侧边栏工具
    handleToggleSidebarTool(params) {
      const { fold } = params;
      console.log(`[TodoPage] 执行切换侧边栏: ${fold}`);
      
      if (fold !== undefined) {
        this.isFold = fold;
      } else {
        this.isFold = !this.isFold;
      }
    },

    // 处理关闭语音助手工具
    handleCloseTool(params) {
      console.log('[TodoPage] 执行关闭语音助手指令');
      
      // 显示提示消息
      this.$toast({
        message: '语音助手已关闭',
        type: 'success',
        duration: 2000
      });

      // 延迟执行，让用户看到提示
      setTimeout(() => {
        // 调用语音助手组件的确认隐藏方法
        if (this.$refs.voiceAssistant) {
          this.$refs.voiceAssistant.confirmHideVoiceButton();
        }
      }, 500);
    },

    // AI接口错误处理
    handleAIError(data) {
      console.log('[TodoPage] AI接口错误:', data);
      
      // 检查深度搜索是否已被取消
      if (this.deepSearchCancelled) {
        console.log('[TodoPage] 深度搜索已被取消，忽略错误');
        return;
      }
      
      // 关闭深度搜索Dialog（如果存在）
      if (this.deepSearchToast) {
        this.deepSearchToast = null;
        Dialog.close();
      }
      this.isDeepSearching = false;
      
      this.$toast({
        message: 'AI处理失败',
        type: 'fail',
        duration: 2000
      });
    },
  },
};
</script>
<style lang="less" scoped>
.show-search {
  position: fixed;
  z-index: 999;
  top: 50px;
  right: 0;
  width: 75vw;
  background: #fff;
  &.is-stretch {
    width: 100vw;
  }
}
.show-search-list {
  /* 默认：只有搜索框，无工具栏 */
  margin-top: 50px;
  
  /* 有工具栏时增加边距 */
  &.with-toolbar {
    margin-top: 98px; /* 搜索框(约50px) + 工具栏(约48px) */
  }
  
  /* 无工具栏时保持原边距 */
  &.without-toolbar {
    margin-top: 50px;
  }
}
.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
.icon-left {
  width: 2em;
}
.navbar {
  left: 0;
  transition: left 0.2s ease-out;
  &.is-fold {
    left: -25vw;
    transition: left 0.2s ease-out;
  }
}
.todo-box {
  .nav {
    position: fixed;
    left: 0;
    transition: left 0.2s ease-out;
    display: flex;
    flex-direction: column;
    &.is-fold {
      left: -25vw;
      transition: left 0.2s ease-out;
    }
    overflow: hidden;
    background-color: #f7f8fa;
    &::-webkit-scrollbar {
      display: none;
    }
    height: 100%;
    .sidebar {
      width: 25vw;
      flex: 1;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
  .content {
    overflow: hidden;
    height: 100%;
    .todo-title {
      position: fixed;
      width: 75vw;
      top: 0;
      height: 50px;
      z-index: 999;
      background: #fff;
      transition: all 0.2s ease-out;
      background-color: #f7f8fa;
      &.is-stretch {
        width: 100vw;
        transition: width 0.2s ease-out;
      }
    }
    .todo-list {
      margin-top: 50px;
      width: 75vw;
      transition: width 0.2s ease-out;
    }
    display: flex;
    .list-box {
      margin-left: 25vw;
      display: flex;
      flex-direction: column;
      flex: 1 0 auto;
      height: 100%;
      overflow: scroll;
      transition: margin-left 0.2s ease-out;
      &.is-stretch {
        margin-left: 0;
        transition: margin-left 0.2s ease-out;
        .todo-list {
          width: 100vw;
          transition: width 0.2s ease-out;
        }
      }
      .van-pull-refresh {
        flex: 1 0 auto;
      }
      ::v-deep .van-cell {
        color: #000;
      }
      .details-box {
        .top {
          display: flex;
          justify-content: space-evenly;
        }
        .foot {
          .foot-item {
            display: flex;
            justify-content: flex-end;
            .van-button {
              height: 30px;
            }
          }
        }
      }
    }
  }
}

/* 工具栏按钮统一样式 */
.toolbar-button {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  background: #f7f8fa;
  transition: background 0.2s;
  user-select: none;
}

.toolbar-button:hover {
  background: #efefef;
}

.toolbar-button__text {
  font-size: 13px;
  color: #666;
  white-space: nowrap;
}
</style>
